import SecureLS from "secure-ls";

const sls = new SecureLS({
  isCompression: false
});

export default sls;